/**
* @fileoverview This file is generated by the Angular template compiler.
* Do not edit.
* @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
* tslint:disable
*/
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var styles = ["button[_ngcontent-%COMP%] {\n  background: #9c2aa0;\n  border-radius: 3px;\n  box-shadow: 0px 1px 2px rgba(50, 50, 50, 0.75);\n  color: #fff;\n  display: inline-block;\n  font-size: 16px;\n  font-weight: 700;\n  margin: 0 6px 10px 0;\n  padding: 10px 20px 11px;\n  text-align: center;\n  text-shadow: 0 -1px #222222;\n  text-decoration: none;\n  line-height: 1;\n  border: 1px solid transparent;\n  cursor: pointer;\n  white-space: nowrap;\n  height: 37px;\n  line-height: 37px;\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n  overflow: hidden;\n  outline: none !important; }\n  button.disabled[_ngcontent-%COMP%] {\n    background: #ccc;\n    color: #333;\n    cursor: normal;\n    text-shadow: none; }"];
export { styles as styles };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/shared/components/action-button/action-button.component.scss.shim.ngstyle.js
// module id = null
// module chunks = 